
import {defineComponent, nextTick} from 'vue'
import {TmsGaDto} from "../../ob1/dto/TmsGaDto";

export default defineComponent({
    name: "OverlayDialog",
    props: {
        // id de l'modal
        id: {
            type: String,
            required: true
        },
        actionLabel: {
            type: String,
            required: true
        },
        modalCloseLabel: {
            type: String,
            required: false,
            default: "Fermer"
        },
        modalTitle: {
            type: String,
            required: false,
            default: null
        },
        modalContent: {
            type: String,
            required: false,
            default: null
        },
        isModalButtonClose: {
            type: Boolean,
            required: false,
            default: true
        },
        modalButtonLabel: {
            type: String,
            required: true
        },
        isModalButtonPrimary: {
            type: Boolean,
            required: false,
            default: true
        },
        isActionButton: {
            type: Boolean,
            required: false,
            default: true
        },
        imageUrl: {
            type: String,
            required: false,
            default: null
        },
        alertHtmlContent: {
            type: String,
            required: false,
            default: null
        },
        htmlContent: {
            type: String,
            required: false,
            default: null
        },
        tmsCategory: {
            type: String,
            required: false,
            default: ""
        },
        tmsLabel: {
            type: String,
            required: false,
            default: "ouverture-popin"
        },
        isAutoOpened: {
            type: Boolean,
            required: false,
            default: false
        },
        isIconButton: {
            type: Boolean,
            required: false,
            default: false
        },
        iconName: {
            type: String,
            required: false,
            default: ""
        },
        ariaLabel: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        labelId() {
            return this.id + '-label'
        },
        actionTms(): TmsGaDto {
            return {
                category: this.tmsCategory,
                action: toBroadbandTmsFormat(this.actionLabel),
                label: toBroadbandTmsFormat(this.tmsLabel)
            }
        },
        buttonClass() {
            if (this.isActionButton) return 'btn btn-primary';
            if (this.isIconButton) return 'ob1-link-icon';
            return 'ob1-link-arrow';
        }
    },
    watch: {
        isAutoOpened(newIsAutoOpened, _) {
            console.log("isAutoOpenedChange")
            this.openModal(newIsAutoOpened);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.openModal(this.isAutoOpened);
        });
    },
    methods: {
        openModal(isAutoOpened: boolean) {
            if (isAutoOpened) {
                const modalButtonOpener = (document.querySelector('[data-bs-toggle="modal"]') as HTMLElement);
                if (modalButtonOpener) modalButtonOpener.click();
            }
        }
    }
})
